export default __webpack_public_path__ + "static/media/training_and_education-dk.3298a190.svg";